import authentication from "@irati/auth"
import {useCompanyNews} from "@irati/culture-hub/hooks/tenantHomePage"
import devToggles from "@irati/dev-toggles"
import Products from "../enums/Products"
import ProductTrackingNames from "../enums/ProductTrackingNames"
import Product from "../types/Product"
import {CompanyNewsTileType} from "@irati/types"

const productList = (): Product[] => {
  const {perks, recognition, medical, wellnessHub, wallet, admin, benefits} = authentication.apps()
  const {data} = useCompanyNews({tenantId: authentication.business().uuid})
  const filteredCultureHubCards = data?.filter((card) => card.config.type !== CompanyNewsTileType.Empty) || []

  return [
    {
      product: Products.perks,
      active: !!perks,
      trackingName: ProductTrackingNames.perks
    },
    {
      product: Products.recognition,
      active: !!recognition,
      trackingName: ProductTrackingNames.recognition
    },
    {
      product: Products.rewards,
      active: !!wallet?.flexiRewards?.view,
      trackingName: ProductTrackingNames.rewards
    },
    {
      product: Products.he,
      active: !!benefits?.he && !devToggles.showPayrollPayNewFlow(),
      trackingName: ProductTrackingNames.he
    },
    {
      product: Products.homeAndElectronics,
      active: !!benefits?.he && devToggles.showPayrollPayNewFlow(),
      trackingName: ProductTrackingNames.homeAndElectronics
    },
    {
      product: Products.ctw,
      active: !!benefits?.ctw && !devToggles.showPayrollPayNewFlow(),
      trackingName: ProductTrackingNames.ctw
    },
    {
      product: Products.cycleToWork,
      active: !!benefits?.ctw && devToggles.showPayrollPayNewFlow(),
      trackingName: ProductTrackingNames.cycleToWork
    },
    {
      product: Products.alp,
      active: !!benefits?.alp && !devToggles.showPayrollPayNewFlow(),
      trackingName: ProductTrackingNames.alp
    },
    {
      product: Products.annualLeavePurchase,
      active: !!benefits?.alp && devToggles.showPayrollPayNewFlow(),
      trackingName: ProductTrackingNames.annualLeavePurchase
    },
    {
      product: Products.cultureHub,
      active: !!admin || filteredCultureHubCards?.length > 0,
      trackingName: ProductTrackingNames.culturehub
    },
    {
      product: Products.wellness,
      active: !!wellnessHub,
      trackingName: ProductTrackingNames.wellness
    },
    {
      product: Products.medical,
      active: !!medical?.medical,
      trackingName: ProductTrackingNames.medical
    },
    {
      product: Products.onlineGP,
      active: !!medical?.onlineGP,
      trackingName: ProductTrackingNames.onlineGP
    }
  ]
}

export default productList
